import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';
import { PlatformComponentsModule } from '../app-platform-core-components';

@NgModule({
    imports: [
        TranslateModule.forChild(),
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        }),
        MatButtonModule,
        MatIconModule,
        CommonModule,
        PlatformComponentsModule
    ],
    exports: [NoDataFoundComponent],
    declarations: [NoDataFoundComponent],
    providers: []
})
export class PlatformNoDataFoundModule {}
